module.exports = __webpack_public_path__ + "img/img (16).d09bd3ce.jpg";